'use strict';

var notificationSettingsService = function ($q, $http, userModel, settings, utils) {
  'ngInject';
  return {
    fetch: function () {
      var promises = [];

      promises.push($http.get(utils.getApiUrl('settings/' + userModel.item.id + '/notifications')));
      promises.push(settings.fetch());

      return $q.all(promises)
        .then(function (result) {
          var settingsValues = result[1];

          this.values = result[0].data;

          if (!settings.isValid('email')) {
            delete this.values.email;
          } else {
            this.email = settingsValues.email.value;
          }

          if (!settings.isValid('phone')) {
            delete this.values.phone;
          } else {
            this.phone = settingsValues.phone.value;
          }

          if (!settings.isValid('fbMessengerId')) {
            delete this.values.fbMessengerId;
          } else {
            this.fbMessengerId = settingsValues.fbMessengerId.value;
          }

        }.bind(this));
    },
    save: function (data) {
      // TODO: refactor checkboxes into dynamic generator for checkbox values
      return $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/notifications'), data)
        .then(function () {
          angular.extend(this.values, data);
        }.bind(this));
    }
  };
};

export default angular
  .module('notificationSettings.notificationSettings', [])
  .service('notificationSettings', notificationSettingsService)
  .name;



// WEBPACK FOOTER //
// ./app/src/modules/notification_settings/notification_settings.service.js